<template>
  <v-card
    outlined
    elevation="2"
    height="calc(100vh - 100px)"
    class="overflow-y-auto"
  >
    <v-card-title class="sticky-title">
      <!-- selects para filtrar informacion -->
      <v-row class="justify-space-between">
        <v-col cols="12" sm="2">
          <v-autocomplete
            outlined
            dense
            clearable
            label="Competencia"
            :items="competencias"
            item-value="id"
            item-text="competencia"
            v-model="competencia"
            @change="cargarDatos"
          >
          </v-autocomplete>
        </v-col>

        <v-col cols="12" sm="2">
          <v-autocomplete
            outlined
            dense
            clearable
            label="Categoría"
            :items="categorias"
            item-value="id"
            item-text="categoria"
            v-model="categoria"
            @change="cargarDatos"
          >
          </v-autocomplete>
        </v-col>

        <v-col cols="12" sm="2">
          <v-autocomplete
            outlined
            dense
            clearable
            label="Saber"
            :items="saberes"
            item-value="id"
            item-text="saber"
            v-model="saber"
            @change="cargarDatos"
          >
          </v-autocomplete>
        </v-col>

        <v-col cols="12" sm="2">
          <v-autocomplete
            outlined
            dense
            clearable
            label="Regional"
            :items="regionales"
            item-value="id"
            item-text="regional"
            v-model="regional"
            @change="cargarDatos"
          >
          </v-autocomplete>
        </v-col>

        <v-col cols="12" sm="2">
          <v-autocomplete
            outlined
            dense
            clearable
            label="Centro de Formación*"
            :items="centrosFormacion"
            item-value="id"
            item-text="centro_formacion"
            v-model="centroFormacion"
            @change="cargarDatos"
          >
          </v-autocomplete>
        </v-col>
      </v-row>

      <!-- contadores de registros -->
      <v-row>
        <v-col cols="12" sm="3">
          <CounterCard
            color="#FF5722"
            :value="saberesTotales"
            icon="mdi-folder-multiple"
            label="Saberes"
          />
        </v-col>

        <v-col cols="12" sm="3">
          <CounterCard
            color="#9C27B0"
            :value="cuposTotales"
            icon="mdi-text-box-plus"
            label="Cupos"
          />
        </v-col>

        <v-col cols="12" sm="3">
          <CounterCard
            color="#3F51B5"
            :value="participantesTotales"
            icon="mdi-account-group"
            label="Participantes"
          />
        </v-col>

        <v-col cols="12" sm="3">
          <CounterCard
            color="#4CAF50"
            :value="85"
            icon="mdi-account-multiple"
            label="Lideres"
          />
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <!-- grafica participantes por categoria -->
      <v-row>
        <v-col cols="12">
          <v-card outlined elevation="2">
            <v-card-text>
              <BarChart
                :data="participantesCuposSaberData"
                :options="participantesCuposSaberOptions"
              >
              </BarChart>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      
      <v-row>
        <v-col cols="12" sm="6">
          <v-card outlined elevation="2">
            <v-card-text>
              <PieChart :data="cuposSaberData" :options="cuposSaberOptions">
              </PieChart>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card outlined elevation="2">
            <v-card-text>
              <PieChart
                :data="participantesSaberData"
                :options="participantesSaberOptions"
              >
              </PieChart>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card outlined elevation="2">
            <v-card-text>
              <BarChart
                :data="participantesCuposCategoriaData"
                :options="participantesCuposCategoriaOptions"
              >
              </BarChart>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <v-card outlined elevation="2">
            <v-card-text>
              <PieChart
                :data="participantesCategoriaData"
                :options="participantesCategoriaOptions"
              >
              </PieChart>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card outlined elevation="2">
            <v-card-text>
              <PieChart
                :data="cuposCategoriaData"
                :options="cuposCategoriaOptions"
              >
              </PieChart>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card outlined elevation="2">
            <v-card-text>
              <BarChart
                :data="participantesCuposRegionalData"
                :options="participantesCuposRegionalOptions"
              >
              </BarChart>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import CounterCard from "../../../components/admin/CounterCard.vue";
import BarChart from "../../../components/admin/BarChart.vue";
import PieChart from "../../../components/admin/PieChart.vue";

export default {
  data: () => ({
    competencia: null,
    categoria: null,
    saber: null,
    regional: null,
    centroFormacion: null,
  }),
  components: {
    CounterCard,
    BarChart,
    PieChart,
  },

  mounted() {
    this.$store.dispatch("gestionarCompetenciasCampesena");
    this.$store.dispatch("gestionarCategoriasCampesena");
    this.$store.dispatch("gestionarSaberesCampesena", 0);
    this.$store.dispatch("crearRegionales");
    this.$store.dispatch("crearCentrosFormacion");
    this.$store.dispatch("gestionarParticipantesCampesenaSaberesTablero", null);
    this.$store.dispatch("gestionarCuposCampesenaSaberesTablero", null);
    this.$store.dispatch(
      "gestionarParticipantesCampesenaCategoriaTablero",
      null
    );
    this.$store.dispatch("gestionarCuposCampesenaCategoriasTablero", null);
    this.$store.dispatch(
      "gestionarParticipantesCampesenaRegionalTablero",
      null
    );
    this.$store.dispatch("gestionarCuposCampesenaRegionalTablero", null);
  },

  computed: {
    competencias() {
      return this.$store.getters.obtenerCompetenciasCampesena;
    },
    categorias() {
      return this.$store.getters.obtenerCategoriasCampesena;
    },
    saberes() {
      return this.$store.getters.obtenerSaberes;
    },
    regionales() {
      return this.$store.getters.obtenerRegionales;
    },
    centrosFormacion() {
      return this.$store.getters.obtenerCentrosFormacionTablero;
    },
    participantesSaberesTablero() {
      return this.$store.getters.obtenerParticipanteSaberesTablero;
    },
    cuposSaberesTablero() {
      return this.$store.getters.obtenerCuposCampesenaSaberesTablero;
    },
    participantesCategoriasTablero() {
      return this.$store.getters.obtenerParticipanteCategoriasTablero;
    },
    cuposCategoriasTablero() {
      return this.$store.getters.obtenerCuposCampesenaCategoriasTablero;
    },
    participantesRegionalTablero() {
      return this.$store.getters.obtenerParticipantesRegionalTablero;
    },
    cuposRegionalTablero() {
      return this.$store.getters.obtenerCuposCampesenaRegionalTablero;
    },

    //valores
    saberesTotales() {
      return this.cuposSaberesTablero.length;
    },
    participantesTotales() {
      return this.participantesSaberesTablero.reduce(
        (sum, p) => sum + p.participantes,
        0
      );
    },
    cuposTotales() {
      return this.cuposSaberesTablero.reduce((sum, c) => sum + c.cupos, 0);
    },

    // options y data graficas
    // Barchats
    participantesCuposSaberData() {
      const saberes = this.cuposSaberesTablero.map((p) => p.saber);
      const participantes = this.participantesSaberesTablero.map(
        (p) => p.participantes
      );
      const cupos = this.cuposSaberesTablero.map((c) => c.cupos);

      return {
        labels: saberes,
        datasets: [
          {
            label: "Cupos",
            data: cupos,
            backgroundColor: "#E1BEE7",
            borderColor: "#9C27B0",
            borderWidth: 2,
          },
          {
            label: "Participantes",
            data: participantes,
            backgroundColor: "#C5CAE9",
            borderColor: "#3F51B5",
            borderWidth: 2,
          },
        ],
      };
    },
    participantesCuposSaberOptions() {
      const chartOptions = {
        indexAxis: "y",
        scales: {
          x: {
            grid: {
              display: false,
            },
          },
          y: {
            ticks: {
              autoSkip: false,
              callback: function (val) {
                const texto = this.getLabelForValue(val);

                if (texto.length > 80) {
                  // Corta el texto y añade "..."
                  return texto.slice(0, 80) + "...";
                } else {
                  // Si no excede el límite, devuelve el texto original
                  return texto;
                }
              },
            },
            grid: {
              display: false,
            },
          },
        },
      };

      return chartOptions;
    },

    cuposSaberData() {
      const saberes = this.cuposSaberesTablero.map((p) => p.saber);
      const cupos = this.cuposSaberesTablero.map((p) => p.cupos);
      return {
        labels: saberes,
        datasets: [
          {
            data: this.generarPorcentaje(cupos),
            backgroundColor: this.generarColorRGB(saberes.length),
          },
        ],
      };
    },
    cuposSaberOptions() {
      return {
        hoverOffset: 8,
        cutout: "50%",
        plugins: {
          legend: {
            display: false,
          },
          title: {
            display: true,
            text: "Cupos por saber",
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                return context.label + ": " + context.parsed + "%";
              },
            },
          },
        },
      };
    },

    participantesSaberData() {
      const saberes = this.participantesSaberesTablero.map((p) => p.saber);
      const participantes = this.participantesSaberesTablero.map(
        (p) => p.participantes
      );
      return {
        labels: saberes,
        datasets: [
          {
            data: this.generarPorcentaje(participantes),
            backgroundColor: this.generarColorRGB(saberes.length),
          },
        ],
      };
    },
    participantesSaberOptions() {
      return {
        hoverOffset: 8,
        cutout: "50%",
        plugins: {
          legend: {
            display: false,
          },
          title: {
            display: true,
            text: "Participantes por saber",
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                return context.label + ": " + context.parsed + "%";
              },
            },
          },
        },
      };
    },

    participantesCategoriaData() {
      const categorias = this.participantesCategoriasTablero.map(
        (p) => p.categoria
      );
      const participantes = this.participantesCategoriasTablero.map(
        (p) => p.participantes
      );
      return {
        labels: categorias,
        datasets: [
          {
            data: this.generarPorcentaje(participantes),
            backgroundColor: this.generarColorRGB(categorias.length),
          },
        ],
      };
    },
    participantesCategoriaOptions() {
      return {
        hoverOffset: 8,
        cutout: "50%",
        plugins: {
          legend: {
            display: false,
          },
          title: {
            display: true,
            text: "Participantes por categorias",
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                return context.label + ": " + context.parsed + "%";
              },
            },
          },
        },
      };
    },

    cuposCategoriaData() {
      const categorias = this.cuposCategoriasTablero.map((p) => p.categoria);
      const cupos = this.cuposCategoriasTablero.map((p) => p.cupos);
      return {
        labels: categorias,
        datasets: [
          {
            data: this.generarPorcentaje(cupos),
            backgroundColor: this.generarColorRGB(categorias.length),
          },
        ],
      };
    },
    cuposCategoriaOptions() {
      return {
        hoverOffset: 8,
        cutout: "50%",
        plugins: {
          legend: {
            display: false,
          },
          title: {
            display: true,
            text: "Cupos por Categorias",
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                return context.label + ": " + context.parsed + "%";
              },
            },
          },
        },
      };
    },

    participantesCuposCategoriaData() {
      const categorias = this.cuposCategoriasTablero.map((p) => p.categoria);
      const participantes = this.participantesCategoriasTablero.map(
        (p) => p.participantes
      );
      const cupos = this.cuposCategoriasTablero.map((c) => c.cupos);

      return {
        labels: categorias,
        datasets: [
          {
            label: "Cupos",
            data: cupos,
            backgroundColor: "#E1BEE7",
            borderColor: "#9C27B0",
            borderWidth: 2,
            pointRadius: 10,
            spanGaps: true,
          },
          {
            label: "Participantes",
            data: participantes,
            backgroundColor: "#C5CAE9",
            borderColor: "#3F51B5",
            borderWidth: 2,
            pointRadius: 10,
          },
        ],
      };
    },
    participantesCuposCategoriaOptions() {
      return {
        responsive: true,
        scales: {
          x: {
            grid: {
              display: false,
            },
          },
          y: {
            grid: {
              display: false,
            },
          },
        },
      };
    },
    participantesCuposRegionalData() {
      const regionales = this.cuposRegionalTablero.map((p) => p.regional);
      const participantes = this.participantesRegionalTablero.map(
        (p) => p.participantes
      );
      const cupos = this.cuposRegionalTablero.map((c) => c.cupos);

      return {
        labels: regionales,
        datasets: [
          {
            label: "Cupos",
            data: cupos,
            backgroundColor: "#E1BEE7",
            borderColor: "#9C27B0",
            borderWidth: 2,
            pointRadius: 10,
            spanGaps: true,
          },
          {
            label: "Participantes",
            data: participantes,
            backgroundColor: "#C5CAE9",
            borderColor: "#3F51B5",
            borderWidth: 2,
            pointRadius: 10,
          },
        ],
      };
    },
    participantesCuposRegionalOptions() {
      return {
        indexAxis: "y",
        scales: {
          x: {
            grid: {
              display: false,
            },
          },
          y: {
            grid: {
              display: false,
            },
            ticks: {
              autoSkip: false,
            },
          },
        },
      };
    },
  },

  methods: {
    cargarDatos() {
      const filtros = {
        competencia: this.competencia,
        categoria: this.categoria,
        saber: this.saber,
        regional: this.regional,
        centro_formacion: this.centroFormacion,
      };
      this.$store.dispatch(
        "gestionarParticipantesCampesenaSaberesTablero",
        filtros
      );
      this.$store.dispatch("gestionarCuposCampesenaSaberesTablero", filtros);
      this.$store.dispatch(
        "gestionarParticipantesCampesenaCategoriaTablero",
        filtros
      );
      this.$store.dispatch("gestionarCuposCampesenaCategoriasTablero", filtros);
      this.$store.dispatch(
        "gestionarParticipantesCampesenaRegionalTablero",
        filtros
      );
      this.$store.dispatch("gestionarCuposCampesenaRegionalTablero", filtros);
    },
    generarPorcentaje(valores) {
      const total = valores.reduce(
        (suma, currentValue) => suma + currentValue,
        0
      );
      const porcentaje = valores.map((valor) =>
        ((valor / total) * 100).toFixed(1)
      );
      return porcentaje;
    },
    generarColorRGB(cantidad) {
      const coloresAleatorios = [];

      for (let i = 0; i < cantidad; i++) {
        const r = Math.floor(Math.random() * 256);
        const g = Math.floor(Math.random() * 256);
        const b = Math.floor(Math.random() * 256);
        coloresAleatorios.push(`rgb(${r}, ${g}, ${b})`);
      }
      return coloresAleatorios;
    },
  },
};
</script>
<style scoped>
.sticky-title {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1;
}
</style>
